import React, {useMemo} from 'react';
import { Motion, spring } from 'react-motion';
import './SimpleMarker.css';

export default function SimpleMarker({
  pointId,
  lat,
  lng,
  openFileDialog,
  zoom,
  setMapProps,
  isSelected,
  onPage,
  markerId = '',
  initialScale = 0.3,
  defaultScale = 0.6,
  hoveredScale = 0.7,
  hovered = false,
  stiffness = 320,
  damping = 7,
  precision = 0.001,
  $prerender,
}) {
  const handleClick = () => {
    if (openFileDialog) {
      openFileDialog(pointId);
    } else if (zoom < 14) {
      setMapProps({ center: { lat, lng }, zoom: zoom + 1 });
    }
  };

  const classNames = ['simple-marker'];
  if (isSelected) classNames.push('simple-selected');
  if (onPage) classNames.push('simple-page');

  const defaultMotionStyle = useMemo(
    () => ({ scale: $prerender ? defaultScale : initialScale }),
    [initialScale, defaultScale, $prerender]
  );

  const motionStyle = useMemo(
    () => ({
      scale: spring(hovered ? hoveredScale : defaultScale, {
        stiffness,
        damping,
        precision,
      }),
    }),
    [hovered, hoveredScale, defaultScale, stiffness, damping, precision]
  );

  return (
    <Motion defaultStyle={defaultMotionStyle} style={motionStyle}>
      {({ scale }) => (
        <div
          className={classNames.join(' ')}
          style={{ transform: `translate3D(0,0,0) scale(${scale}, ${scale})` }}
          onClick={handleClick}
        />
      )}
    </Motion>
  );
}